import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const PriceVariationsGraph = ({ data }) => {
  if (data) {
    return (
      <Bar
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: false,
              position: "bottom" as const,
            },
          },
          scales: {
            y: {
              type: "linear" as const,
              display: true,
              position: "left" as const,
              grid: {
                drawOnChartArea: false,
              },
              ticks: {
                callback: function (value) {
                  // Only show integer values
                  return Number.isInteger(value) ? value + " €" : null;
                },
              },
            },
          },
        }}
        data={{
          labels: data?.map((scan) => {
            let date = new Date(scan.createdAt);
            const joursSemaine = [
              "dim",
              "lun",
              "mar",
              "mer",
              "jeu",
              "ven",
              "sam",
            ];
            let jourSemaine = joursSemaine[date.getDay()];
            let jour = date.getDate().toString().padStart(2, "0");
            let mois = (date.getMonth() + 1).toString().padStart(2, "0");
            let annee = date.getFullYear();
            let heures = date.getHours().toString().padStart(2, "0");

            return `${jourSemaine} ${jour}/${mois}`;
          }),
          datasets: [
            {
              label: "Évolution du prix",
              data: data?.map((scan) => scan.q),
              borderColor: "rgb(53, 162, 235)",
              backgroundColor: "rgba(53, 162, 235, 0.5)",
            },
          ],
        }}
      />
    );
  }

  return null;
};
